import classNames from 'classnames';
import React from 'react';
import { ListingCarousel } from '../../../../components';
import { useIntl } from '../../../../util/reactIntl';

import Field, { hasDataInFields } from '../../Field';
import { AnimateIn } from '../../../../components';

import SectionContainer from '../SectionContainer';
import css from './SectionRecentListings.module.css';
import {
  homeBoostedSectionId,
  recentSectionId,
  shopByItemTypeId,
} from '../../../LandingPage/LandingPage.duck';
import useViewportSize from '../../../../hooks/useViewportSize';

const COLUMN_CONFIG = [
  { css: css.oneColumn, responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { css: css.twoColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { css: css.threeColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { css: css.fourColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 265px' },
];
const getIndex = numColumns => numColumns - 1;
const getColumnCSS = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.css : COLUMN_CONFIG[0].css;
};

const MAX_SLIDES_TO_SHOW_FOR_LISTINGS = 6;
const MAX_SLIDES_TO_SHOW_FOR_BLOCKS = 4;

const SectionRecentListings = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    isInsideContainer,
    options,
    listings = [],
    blocks = [],
    useFullWidth: useFullWidthProp = false,
  } = props;
  const intl = useIntl();
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasListings = listings.length > 0 || blocks.length > 0;
  const slidesToShow =
    listings.length > 0 || sectionId === shopByItemTypeId
      ? MAX_SLIDES_TO_SHOW_FOR_LISTINGS
      : blocks.length < MAX_SLIDES_TO_SHOW_FOR_BLOCKS
      ? blocks.length
      : MAX_SLIDES_TO_SHOW_FOR_BLOCKS;

  const { isMobile } = useViewportSize();
  const useFullWidthLandingPage = [
    recentSectionId,
    homeBoostedSectionId,
    shopByItemTypeId,
  ].includes(sectionId);
  const useFullWidth = useFullWidthProp || useFullWidthLandingPage;

  // Autoplay only for listing carousels, not shop-by-category
  const shouldAutoplay = [homeBoostedSectionId, recentSectionId].includes(sectionId);
  const hideCardDescription = [homeBoostedSectionId, recentSectionId].includes(sectionId);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <AnimateIn>
          <header className={defaultClasses.sectionDetails}>
            <Field data={title} className={defaultClasses.title} options={fieldOptions} />
            <Field data={description} className={defaultClasses.description} options={fieldOptions} />
            <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
          </header>
        </AnimateIn>
      ) : null}

      {hasListings ? (
        <AnimateIn delay={1}>
          <div
            className={classNames(css.carouselContainer, {
              [css.noSidePaddings]: isInsideContainer,
              [css.carouselContainerWithFullWidth]: useFullWidth,
            })}
          >
            <ListingCarousel
              carouselWrapperClassName={css.carouselWrapperWithFullWidth}
              id={`${sectionId}-carousel`}
              listings={listings}
              blocks={blocks}
              slidesToShow={slidesToShow}
              loop={false}
              showArrows
              showDots={false}
              autoplay={shouldAutoplay}
              autoplaySpeed={4000}
              addMarginLeft={isMobile}
              useBigTitle={sectionId === shopByItemTypeId}
              hideDescription={hideCardDescription}
            />
          </div>
        </AnimateIn>
      ) : null}
    </SectionContainer>
  );
};

export default SectionRecentListings;
